import { useTheme } from "@emotion/react";
import {
	AngryEmoji,
	HappyEmoji,
	NeutralEmoji,
	OverwhelmedEmoji,
	SadEmoji,
} from "myplan/components/Icon";
import React from "react";
import { TouchableOpacity } from "react-native";
import { Container } from "./styles";

export type EmojiType = "happy" | "neutral" | "overwhelmed" | "sad" | "angry";

const EMOJI_WIDTH = 45;

type EmojiProps = {
	type: EmojiType;
	isActive?: Boolean;
	onPress?: (type: EmojiType) => void;
};

const Emoji = ({ type, isActive, onPress }: EmojiProps) => {
	const { verticalScale, color: themeColor }: any = useTheme();
	const color = isActive ? themeColor.secondaryAccent : themeColor.enabled;
	const width = verticalScale < 1 ? EMOJI_WIDTH * verticalScale : EMOJI_WIDTH;
	let Icon;

	const _onPress = () => onPress?.(type);

	switch (type) {
		case "happy":
			Icon = HappyEmoji;
			break;

		case "neutral":
			Icon = NeutralEmoji;
			break;

		case "overwhelmed":
			Icon = OverwhelmedEmoji;
			break;

		case "sad":
			Icon = SadEmoji;
			break;

		case "angry":
			Icon = AngryEmoji;
			break;
	}

	return (
		<TouchableOpacity onPress={_onPress}>
			<Container>
				<Icon width={width} height={width} color={color} />
			</Container>
		</TouchableOpacity>
	);
};

export default Emoji;
